__turbopack_context__.v({
  "detail": "clientItem-module-scss-module__s6XF4q__detail",
  "detail-icon": "clientItem-module-scss-module__s6XF4q__detail-icon",
  "entityContainer": "clientItem-module-scss-module__s6XF4q__entityContainer",
  "entityContainer-selectable": "clientItem-module-scss-module__s6XF4q__entityContainer-selectable",
  "entityInfo": "clientItem-module-scss-module__s6XF4q__entityInfo",
  "entityInfoRow": "clientItem-module-scss-module__s6XF4q__entityInfoRow",
  "h10": "clientItem-module-scss-module__s6XF4q__h10",
  "h15": "clientItem-module-scss-module__s6XF4q__h15",
  "h20": "clientItem-module-scss-module__s6XF4q__h20",
  "name": "clientItem-module-scss-module__s6XF4q__name",
  "name-container": "clientItem-module-scss-module__s6XF4q__name-container",
  "reference": "clientItem-module-scss-module__s6XF4q__reference",
  "skeleton-clientRow": "clientItem-module-scss-module__s6XF4q__skeleton-clientRow",
  "tooltip": "clientItem-module-scss-module__s6XF4q__tooltip",
  "tooltiptext": "clientItem-module-scss-module__s6XF4q__tooltiptext",
  "w50": "clientItem-module-scss-module__s6XF4q__w50",
  "w75": "clientItem-module-scss-module__s6XF4q__w75",
  "w90": "clientItem-module-scss-module__s6XF4q__w90",
});
